import { GlobalStatusEnum } from "@/model/data/status/GlobalStatusEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationsResData } from "../device/GetInstallationsResData";
import { ConnectivityStatusEnum } from "@/model/data/status/ConnectivityStatusEnum";

const ENDPOINT = "/license/installations_enabled_modules";

export class GetInstallationsEnabledModulesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: GetInstallationsEnabledModulesServerReqData = null;

    constructor(params: GetInstallationsEnabledModulesServerReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetInstallationsResData> {
        let res = await this.executeCommand(this.params);
        return new GetInstallationsResData(res);
    }
}

export interface GetInstallationsEnabledModulesServerReqData {
    // FilterInstallations
    installationNames: string[];
    folderIds: number[];
    branchNames: string[];

    // PaginationFilters
    queryLimit: number;
    offset: number;
    orderBy: string[];
    orderByDescending: boolean[];

    // Other filters
    globalStatusFilter: GlobalStatusEnum[];
    connectivityStatusFilter: ConnectivityStatusEnum[];
    installationLastMessageDateRange: string[];
    agentLastMessageDateRange: string[];
    registrationDateRange: string[];
    enabledModules: number;
    disabledModules: number;
}
